import { render, staticRenderFns } from "./noCodeContent.vue?vue&type=template&id=33812ac8&scoped=true"
import script from "./noCodeContent.vue?vue&type=script&lang=js"
export * from "./noCodeContent.vue?vue&type=script&lang=js"
import style0 from "./noCodeContent.vue?vue&type=style&index=0&id=33812ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33812ac8",
  null
  
)

export default component.exports